<template>
  <component
    :is="resolvedIcon"
    class="app-lucide-icon"
    :size="size"
    :stroke-width="strokeWidth"
    aria-hidden="true"
  />
</template>

<script>
import LucideIcons from './appIconRegistry'

const ICON_ALIASES = {
  'archive-fill': 'Archive',
  'arrow-down-left-circle': 'CircleArrowOutDownLeft',
  'arrow-down-short': 'ArrowDown',
  'arrow-up-right-circle': 'CircleArrowOutUpRight',
  'arrow-up-short': 'ArrowUp',
  'arrows-collapse': 'Minimize2',
  'arrows-expand': 'Maximize2',
  'aspect-ratio': 'Ratio',
  'bag': 'ShoppingBag',
  'border-bottom': 'PanelBottom',
  'bounding-box': 'BoxSelect',
  'box-arrow-in-right': 'LogIn',
  'box-arrow-up-right': 'ExternalLink',
  'box2': 'Package',
  'building-check': 'Building2',
  'building-exclamation': 'Building2',
  'building-x': 'Building2',
  'calendar-day': 'CalendarDays',
  'calendar-event': 'CalendarDays',
  'calendar-event-fill': 'CalendarDays',
  'calendar-week': 'CalendarDays',
  'calendar2-check': 'CalendarCheck2',
  'card-checklist': 'ListChecks',
  'card-heading': 'Heading',
  'card-list': 'List',
  'cart-check': 'ShoppingCart',
  'chat-dots': 'MessageCircleMore',
  'chat-heart-fill': 'MessageCircleHeart',
  'chat-left-dots-fill': 'MessageSquareMore',
  'chat-left-text': 'MessageSquareText',
  'chat-quote': 'MessageSquareQuote',
  'chat-square-text': 'MessageSquareText',
  'check-all': 'CheckCheck',
  'check-lg': 'Check',
  'check2-all': 'CheckCheck',
  'clipboard2-pulse': 'ClipboardList',
  'cloud-arrow-down-fill': 'CloudDownload',
  'code-slash': 'CodeXml',
  'credit-card-2-front': 'CreditCard',
  'dash': 'Minus',
  'dash-lg': 'Minus',
  'diagram-3': 'Network',
  'envelope-check-fill': 'MailCheck',
  'eye-slash': 'EyeOff',
  'file-earmark-bar-graph': 'FileChartColumn',
  'file-earmark-image': 'FileImage',
  'file-earmark-plus': 'FilePlus2',
  'file-ruled': 'FileText',
  'filter-square': 'ListFilter',
  'fullscreen-exit': 'Minimize',
  'gear': 'Settings',
  'gear-fill': 'Settings',
  'gear-wide-connected': 'Settings',
  'google-play': 'Play',
  'graph-down-arrow': 'TrendingDown',
  'grid-3x3-gap': 'Grid3X3',
  'hdd': 'HardDrive',
  'hdd-network-fill': 'Network',
  'house-door': 'House',
  'journal-check': 'BookCheck',
  'journal-text': 'NotebookText',
  'layers-half': 'Layers',
  'layout-split': 'PanelsTopLeft',
  'layout-text-sidebar-reverse': 'PanelRight',
  'lightning': 'Zap',
  'list-ol': 'ListOrdered',
  'pencil-square': 'SquarePen',
  'person-exclamation': 'CircleUserRound',
  'person-vcard': 'Contact',
  'plus-lg': 'Plus',
  'question-circle': 'CircleHelp',
  'robot': 'Bot',
  'rocket-takeoff-fill': 'Rocket',
  'send-check': 'Send',
  'shield-exclamation': 'ShieldAlert',
  'shop': 'Store',
  'signpost-split': 'Signpost',
  'text-center': 'AlignCenter',
  'text-left': 'AlignLeft',
  'text-paragraph': 'Pilcrow',
  'text-right': 'AlignRight',
  'translate': 'Languages',
  'type-bold': 'Bold',
  'type-h1': 'Heading1',
  'ui-checks-grid': 'ListChecks',
  'window': 'AppWindow',
  'wrench-adjustable': 'Wrench',
  'arrow-clockwise': 'Redo2',
  'arrow-counterclockwise': 'Undo2',
  'arrow-down-circle': 'CircleArrowDown',
  'arrow-down-circle-fill': 'CircleArrowDown',
  'arrow-left-circle': 'CircleArrowLeft',
  'arrow-repeat': 'RefreshCw',
  'arrow-return-left': 'Reply',
  'arrow-right-circle': 'CircleArrowRight',
  'arrow-up-circle': 'CircleArrowUp',
  'arrow-up-circle-fill': 'CircleArrowUp',
  'bag-check': 'PackageCheck',
  'bag-check-fill': 'PackageCheck',
  'bank': 'Landmark',
  'bar-chart': 'ChartNoAxesColumn',
  'bar-chart-fill': 'ChartNoAxesColumn',
  'bar-chart-line': 'ChartNoAxesCombined',
  'bar-chart-steps': 'ChartNoAxesColumnIncreasing',
  'basket': 'ShoppingBasket',
  'bell-fill': 'Bell',
  'box-arrow-left': 'LogOut',
  'box-arrow-right': 'LogIn',
  'box-seam': 'Package',
  'building': 'Building2',
  'calendar2-event': 'CalendarDays',
  'calendar2-x': 'CalendarX',
  'calendar3': 'CalendarDays',
  'cart': 'ShoppingCart',
  'cart3': 'ShoppingCart',
  'cart4': 'ShoppingCart',
  'cart-check-fill': 'ShoppingCart',
  'cash': 'Banknote',
  'cash-coin': 'Coins',
  'cash-stack': 'Banknote',
  'check-circle': 'CircleCheckBig',
  'check-circle-fill': 'CircleCheckBig',
  'check2': 'Check',
  'check2-circle': 'CircleCheck',
  'check2-square': 'SquareCheckBig',
  'clipboard-data': 'ClipboardList',
  'clock-history': 'History',
  'cloud-arrow-up': 'CloudUpload',
  'cloud-check': 'CloudCheck',
  'cloud-slash': 'CloudOff',
  'collection': 'Layers3',
  'copy': 'Copy',
  'currency-dollar': 'DollarSign',
  'currency-exchange': 'ArrowLeftRight',
  'dash-circle': 'CircleMinus',
  'door-closed': 'DoorClosed',
  'door-open': 'DoorOpen',
  'envelope': 'Mail',
  'envelope-paper': 'MailOpen',
  'exclamation-circle': 'CircleAlert',
  'exclamation-circle-fill': 'CircleAlert',
  'exclamation-octagon-fill': 'OctagonAlert',
  'exclamation-triangle': 'TriangleAlert',
  'exclamation-triangle-fill': 'TriangleAlert',
  'file-earmark': 'File',
  'file-earmark-arrow-up': 'FileUp',
  'file-earmark-check': 'FileCheck2',
  'file-earmark-excel': 'Sheet',
  'file-earmark-excel-fill': 'Sheet',
  'file-earmark-image-fill': 'FileImage',
  'file-earmark-pdf': 'FileText',
  'file-earmark-richtext': 'FileType2',
  'file-earmark-spreadsheet': 'Sheet',
  'file-earmark-text': 'FileText',
  'file-earmark-text-fill': 'FileText',
  'file-earmark-word-fill': 'FileText',
  'file-earmark-zip-fill': 'FileArchive',
  'filetype-csv': 'FileSpreadsheet',
  'fonts': 'Type',
  'geo-alt': 'MapPin',
  'graph-down': 'TrendingDown',
  'graph-up': 'ChartNoAxesCombined',
  'graph-up-arrow': 'TrendingUp',
  'grid-1x2': 'PanelsTopLeft',
  'hourglass-split': 'Hourglass',
  'info-circle': 'Info',
  'info-circle-fill': 'Info',
  'layout-sidebar-inset': 'PanelLeftClose',
  'lightning-charge': 'Zap',
  'link-45deg': 'Link2',
  'list-check': 'ListChecks',
  'list-task': 'ListTodo',
  'list-ul': 'List',
  'lock-fill': 'Lock',
  'magic': 'WandSparkles',
  'paperclip': 'Paperclip',
  'pause-fill': 'Pause',
  'people': 'Users',
  'people-fill': 'Users',
  'person': 'UserRound',
  'person-badge': 'Contact',
  'person-check': 'UserCheck',
  'person-check-fill': 'UserCheck',
  'person-lines-fill': 'ContactRound',
  'person-plus': 'UserPlus',
  'person-rolodex': 'ContactRound',
  'person-workspace': 'BriefcaseBusiness',
  'phone': 'Smartphone',
  'pie-chart': 'ChartPie',
  'pie-chart-fill': 'ChartPie',
  'play-btn': 'CirclePlay',
  'play-fill': 'Play',
  'plus-circle': 'CirclePlus',
  'plus-square': 'SquarePlus',
  'plus-square-fill': 'Plus',
  'printer-fill': 'Printer',
  'receipt': 'ReceiptText',
  'receipt-cutoff': 'ReceiptText',
  'save2': 'Save',
  'shield-lock': 'ShieldCheck',
  'shield-lock-fill': 'ShieldCheck',
  'sliders': 'SlidersHorizontal',
  'speedometer': 'Gauge',
  'speedometer2': 'Gauge',
  'sticky': 'StickyNote',
  'tag-fill': 'Tag',
  'telephone': 'Phone',
  'three-dots': 'Ellipsis',
  'three-dots-vertical': 'EllipsisVertical',
  'toggle-off': 'ToggleLeft',
  'toggle-on': 'ToggleRight',
  'trash': 'Trash2',
  'trash3': 'Trash2',
  'unlock-fill': 'LockOpen',
  'upc': 'Barcode',
  'upc-scan': 'ScanBarcode',
  'wallet': 'WalletCards',
  'wallet2': 'WalletCards',
  'whatsapp': 'MessageCircle',
  'x-circle': 'CircleX',
  'x-circle-fill': 'CircleX',
  'x-lg': 'X',
  'x-octagon': 'OctagonX'
}

function flattenIconName(value) {
  if (Array.isArray(value)) return value.map(flattenIconName).join(' ')
  if (value && typeof value === 'object') {
    return Object.keys(value).filter(key => value[key]).join(' ')
  }
  return String(value || '')
}

function toPascalCase(value) {
  return value
    .split('-')
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')
}

function iconCandidates(name) {
  const className = flattenIconName(name)
  const iconClass = className.split(/\s+/).find(value => value.startsWith('bi-')) || className
  const baseName = iconClass.replace(/^bi-/, '')
  const withoutFill = baseName.replace(/-fill$/, '')
  const candidates = [
    ICON_ALIASES[baseName],
    ICON_ALIASES[withoutFill],
    toPascalCase(baseName),
    toPascalCase(withoutFill)
  ]

  const circleMatch = withoutFill.match(/^(.+)-circle$/)
  if (circleMatch) candidates.push(toPascalCase(`circle-${circleMatch[1]}`))

  const squareMatch = withoutFill.match(/^(.+)-square$/)
  if (squareMatch) candidates.push(toPascalCase(`square-${squareMatch[1]}`))

  return candidates.filter(Boolean)
}

export default {
  name: 'AppIcon',
  props: {
    name: {
      type: [String, Array, Object],
      required: true
    },
    size: {
      type: [Number, String],
      default: '1em'
    },
    strokeWidth: {
      type: [Number, String],
      default: 1.75
    }
  },
  computed: {
    resolvedIcon() {
      const match = iconCandidates(this.name).find(candidate => LucideIcons[candidate])
      return LucideIcons[match] || LucideIcons.CircleHelp
    }
  }
}
</script>

<style scoped>
.app-lucide-icon {
  display: inline-block;
  flex: 0 0 auto;
  vertical-align: -0.125em;
}
</style>
